/**
 * 影视页：与 home 一样分 3 页轮播，3 个背景图，每页关卡图 4/5/6 系列
 * 仅左上角回退，无左下/右下/右上；数据不依赖课程接口，按需加载图片
 * 从主页跳转进入时显示 loading，首屏资源就绪后关闭
 * 影视与 Home 独立逻辑：入口不锁。当前展示 11 个子模块；图标可跨页摆放，课程仍按 serial 顺序解锁。
 */
import React, { useRef, useState, useCallback, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Virtual } from 'swiper/modules';
import 'swiper/swiper-bundle.css';
import YingshiSlide from './YingshiSlide';
import back from 'asset/img/back.png';
import Loadding from 'components/Loadding';
import { getCourseList } from 'network/index';
import {
  YINGSHI_GRADE_START_SERIAL,
  YINGSHI_SERIALS,
  YINGSHI_SLIDE_LENS,
} from './courseConfig';
import '../Home/index.scss';
import './index.scss';

const YINGSHI_UNLOCK_STEP = 500;

const Yingshi = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const swiperRef = useRef(null);
  const searchParams = new URLSearchParams(location.search);
  const initialSlide = Math.max(0, Math.min(2, Number(searchParams.get('slide') || 0) || 0));
  const [currentSlide, setCurrentSlide] = useState(initialSlide);
  const [loading, setLoading] = useState(true);
  const [allStatus, setAllStatus] = useState(() => Array(YINGSHI_SERIALS.length).fill(false).fill(true, 0, 1)); // 第1个默认开放
  const isYingshiUnlocked = true;

  useEffect(() => {
    getCourseList({})
      .then((res) => {
        const list = res?.data?.course_list || [];
        const status = [true];
        for (let i = 1; i < YINGSHI_SERIALS.length; i++) {
          const currentSerial = YINGSHI_SERIALS[i];
          if (currentSerial === YINGSHI_GRADE_START_SERIAL) {
            status.push(true);
            continue;
          }
          // 解锁顺序与视觉页面脱钩：例如放在第 2 页的 995 仍由 994 解锁。
          const prevSerial = currentSerial - 1;
          const prevItem = list.find((c) => Number(c.serial_id) === prevSerial);
          const prevStep = prevItem?.curr_step ?? 0;
          status.push(prevStep >= YINGSHI_UNLOCK_STEP);
        }
        setAllStatus(status);
      })
      .catch(() => setAllStatus(Array(YINGSHI_SERIALS.length).fill(false).fill(true, 0, 1)));
  }, []);

  const handleSlideChange = useCallback((swiper) => {
    try {
      const i = swiper?.activeIndex ?? swiper?.realIndex ?? 0;
      if (i >= 0 && i <= 2) setCurrentSlide(i);
    } catch (e) {}
  }, []);

  useEffect(() => {
    const swiper = swiperRef.current?.swiper;
    if (swiper && (swiper.activeIndex ?? 0) !== initialSlide) {
      swiper.slideTo(initialSlide, 0);
    }
    setCurrentSlide(initialSlide);
  }, [initialSlide]);

  return (
    <div className="home-container yingshi-page">
      <Swiper
        ref={swiperRef}
        modules={[Virtual]}
        spaceBetween={0}
        onSlideChange={handleSlideChange}
        onSwiper={(swiper) => {
          if (swiper) {
            if (initialSlide > 0) swiper.slideTo(initialSlide, 0);
            setCurrentSlide(initialSlide);
          }
        }}
        loop={false}
        resistanceRatio={0}
        touchReleaseOnEdges={true}
        direction="horizontal"
        initialSlide={initialSlide}
        virtual={{ enabled: true, addSlidesAfter: 0, addSlidesBefore: 0 }}
        className="swiper"
      >
        {[0, 1, 2].map((type) => (
          <SwiperSlide key={type} className="home-item" virtualIndex={type}>
            <YingshiSlide
              type={type}
              isYingshiUnlocked={isYingshiUnlocked}
              slideStatus={allStatus.slice(
                YINGSHI_SLIDE_LENS.slice(0, type).reduce((a, b) => a + b, 0),
                YINGSHI_SLIDE_LENS.slice(0, type).reduce((a, b) => a + b, 0) + YINGSHI_SLIDE_LENS[type]
              )}
              slideSerials={YINGSHI_SERIALS.slice(
                YINGSHI_SLIDE_LENS.slice(0, type).reduce((a, b) => a + b, 0),
                YINGSHI_SLIDE_LENS.slice(0, type).reduce((a, b) => a + b, 0) + YINGSHI_SLIDE_LENS[type]
              )}
              onImagesLoaded={type === initialSlide ? () => setLoading(false) : undefined}
            />
          </SwiperSlide>
        ))}
      </Swiper>
      <button
        type="button"
        className="yingshi-back"
        onClick={() => navigate('/home')}
        aria-label="返回主页"
      >
        <img src={back} alt="" />
      </button>
      <div className="home-pagination">
        {[0, 1, 2].map((i) => (
          <div
            key={i}
            className={`pagination-dot ${currentSlide === i ? 'active' : ''}`}
            onClick={() => swiperRef.current?.swiper?.slideTo(i)}
            role="button"
            tabIndex={0}
          >
            <span className="dot-emoji">{currentSlide === i ? '⭐' : '✨'}</span>
          </div>
        ))}
      </div>
      {loading && <Loadding visible />}
    </div>
  );
};

export default Yingshi;
